import { applySubmitTile } from "./appliers";
import type { BlackAndWhiteAction, BlackAndWhiteState } from "./types";

export function reduceGameState(
  state: BlackAndWhiteState,
  action: BlackAndWhiteAction,
): BlackAndWhiteState {
  switch (action.type) {
    case "SubmitTile":
      return applySubmitTile(state, action);
  }
}
